export default __webpack_public_path__ + "open-watchlist-3d8f09850483cc790832d268d68c7370.png";